import { Input } from 'antd';
import { useCallback, useState } from 'react';
import { AppModal, Flex } from '../common';
import { useTranslation } from 'react-i18next';

const SelectUniversityModal = ({ universities, hide, onChange = undefined, ...props }) => {

  const [search, setSearch] = useState('');
  const [t] = useTranslation(['common']);

  const handleClick = useCallback((unikey: any) => {
    setSearch('');
    onChange(unikey);
    hide();
  }, [onChange, hide, setSearch]);


  const items = universities?.filter(item => item.universityLabel.includes(search));

  return (
    <AppModal
      destroyOnHidden
      centered
      width="90%"
      variant="glass"
      footer={null}
      onCancel={hide}
      styles={{ body: { height: '70vh', overflow: 'auto' } }}
      style={{ maxWidth: '850px' }}
      title={t('common:labels.select-org', { 'org-type': t('common:labels.university') })}
      {...props}
    >
      <Input
        value={search}
        className="text-center"
        onChange={e => setSearch(e.target.value)}
        placeholder={t('common:messages.search-by-uni')}
      />
      <Flex component="ul" direction="column" className="p-0 m-0 list-none mt-3 select-none">
        {(items ?? []).map((item, i) => (
          <Flex
            key={i}
            component="li"
            className="p-2 rounded-lg hover:bg-[#eee] cursor-pointer"
            onClick={handleClick?.bind(this, item.unikey)}
          >{item.universityLabel}</Flex>
        ))}
      </Flex>
    </AppModal>
  );
};

export default SelectUniversityModal;
